import { Identifiable, OrganizationalUnit } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type LinkedOrganizationalUnit = {
  uuid: string;
  name: string;
  rankKey: string;
  parentUuid: string | null;
};

function editOrganizationalUnit(httpClient: HttpClient) {
  return (organizationalUnit: Identifiable<OrganizationalUnit>, name: string) =>
    httpClient
      .sendHttpRequest<LinkedOrganizationalUnit>({
        endpoint: `/organizational-units/${organizationalUnit.uuid}`,
        method: HttpMethods.PATCH,
        data: { name },
      })
      .then(
        ({
          uuid,
          name,
          rankKey,
          parentUuid,
        }): Identifiable<OrganizationalUnit> => ({
          uuid,
          name,
          rankKey,
          parentUuid: parentUuid ?? undefined,
        }),
      )
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { editOrganizationalUnit };
